const ONBOARDING_VERSION = "v1";

const getOnboardingKey = (userId) => {
  const safeUserId = userId ? String(userId) : "unknown";
  return `onboarding_completed_${ONBOARDING_VERSION}_${safeUserId}`;
};

export const shouldShowOnboarding = (userId) => {
  if (!userId) return true;
  return !localStorage.getItem(getOnboardingKey(userId));
};

export const markOnboardingCompleted = (userId) => {
  if (!userId) return;
  localStorage.setItem(getOnboardingKey(userId), new Date().toISOString());
};
